import React from "react";
import { Path } from "paths";
import SettingNavPage from "./setting-nav-page";
import {
  GeneralSetting,
  TaxSetting,
  PaymentMethodSetting,
  CreditLimitSetting,
  AccountSetting,
  QuestionSetting,
  WristbandTagSetting,
  BanTagList,
  NotificationSetting,
  StockLevelNotification,
  ReceiptSetting,
  IntegrationSetting,
  AccountMapping,
  ChartOfAccounts,
  AdditionalChargeSetting,
  AdditionalChargeSettingAdd,
  AdditionalChargeSettingEdit,
  TipSetting,
  PaymentGatewayList,
  PaymentGatewaySetting,
  PaymentGatewaySettingEdit,
  PaymentGatewaySettingView
} from "modules";
import { RouteRender } from "components/commons";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useMount } from "hooks";
import { setPageTitle } from "services";
import AccessSetting from "modules/setting/access-setting";

const SettingPage = () => {
  const { accountMapping, chartOfAccounts, integrationsSetting } = useFlags();

  useMount(() => {
    setPageTitle("settings");
  });

  return (
    <RouteRender
      defaultRedirect={Path.SETTING}
      renders={{
        [Path.SETTING_GENERAL_SETTING]: {
          exact: true,
          component: GeneralSetting,
        },
        [Path.WRISTBAND_KEEPING]: {
          exact: true,
          component: WristbandTagSetting,
        },
        [Path.SETTING_NOTIFICATION]: {
          exact: false,
          component: NotificationSetting,
        },
        [Path.SETTING_NOTIFICATION_STOCK_LEVEL]: {
          exact: true,
          component: StockLevelNotification,
        },
        [Path.BAN_TAG]: {
          exact: true,
          component: BanTagList,
        },
        [Path.SETTING_TAX]: {
          exact: true,
          component: TaxSetting,
        },
        [Path.SETTING_ADDITIONAL_CHARGE]: {
          exact: true,
          component: AdditionalChargeSetting,
          accessPath: Path.SETTING_ADDITIONAL_CHARGE_LEGACY,
        },
        [Path.SETTING_ADDITIONAL_CHARGE_ADD]: {
          exact: true,
          component: AdditionalChargeSettingAdd,
          accessPath: Path.SETTING_ADDITIONAL_CHARGE_ADD_LEGACY,
        },
        [Path.SETTING_ADDITIONAL_CHARGE_EDIT]: {
          exact: true,
          component: AdditionalChargeSettingEdit,
          accessPath: Path.SETTING_ADDITIONAL_CHARGE_EDIT_LEGACY,
        },
        [Path.SETTING_ADDITIONAL_CHARGE_LEGACY]: {
          exact: true,
          redirectTo: Path.SETTING_ADDITIONAL_CHARGE,
        },
        [Path.SETTING_ADDITIONAL_CHARGE_ADD_LEGACY]: {
          exact: true,
          redirectTo: Path.SETTING_ADDITIONAL_CHARGE_ADD,
        },
        [Path.SETTING_ADDITIONAL_CHARGE_EDIT_LEGACY]: {
          exact: true,
          redirectTo: ({ id }) => Path.SETTING_ADDITIONAL_CHARGE_EDIT_ID(id),
        },
        [Path.SETTING_TIP]: {
          exact: true,
          component: TipSetting,
        },
        [Path.PAYMENT_METHOD_SETTING]: {
          exact: true,
          component: PaymentMethodSetting,
        },
        [Path.CREDIT_LIMIT_SETTING]: {
          exact: true,
          component: CreditLimitSetting,
        },
        [Path.QUESTION_SETTING]: {
          exact: true,
          component: QuestionSetting,
        },
        [Path.ACCOUNT_SETTING]: {
          exact: true,
          component: AccountSetting,
        },
        [Path.RECEIPT_SETTING]: {
          exact: true,
          component: ReceiptSetting,
        },
        [Path.INTEGRATION_SETTING]: {
          exact: true,
          component: IntegrationSetting,
          featureFlag: integrationsSetting,
        },
        [Path.ACCOUNT_MAPPING]: {
          exact: true,
          component: AccountMapping,
          featureFlag: accountMapping,
        },
        [Path.CHART_OF_ACCOUNTS]: {
          exact: true,
          component: ChartOfAccounts,
          featureFlag: chartOfAccounts,
        },
        [Path.SETTING_ACCESS]: {
          exact: true,
          component: AccessSetting,
        },        
        [Path.PAYMENT_GATEWAY_SETTING]: {
          exact: true,
          component: PaymentGatewayList,
        },
        [Path.PAYMENT_GATEWAY_SETTING_ADD]: {
          exact: true,
          component: PaymentGatewaySetting,
        },
        [Path.PAYMENT_GATEWAY_SETTING_EDIT]: {
          exact: true,
          component: PaymentGatewaySettingEdit,
        },
        [Path.PAYMENT_GATEWAY_SETTING_VIEW]: {
          exact: true,
          component: PaymentGatewaySettingView,
        },
        [Path.SETTING]: {
          exact: true,
          component: SettingNavPage,
        },
      }}
    />
  );
};

export default SettingPage;
